module.exports = __webpack_public_path__ + "static/media/bancolombia-pe-004-normal.366f7fcc.svg";